import type { LeagueDivisionId, LeagueSportId } from '../model/types';

/** League home: redirects to the first launched sport; breadcrumbs link it as «Лига Sportyfinder». */
export const leagueRootPath = (): string => '/league';

export const leagueSportPath = (sport: LeagueSportId): string => `${leagueRootPath()}/${sport}`;

export const leagueDivisionPath = (sport: LeagueSportId, divisionId: LeagueDivisionId): string =>
  `${leagueSportPath(sport)}/${divisionId}`;

export const leagueTeamPath = (sport: LeagueSportId, slug: string): string => `${leagueSportPath(sport)}/teams/${slug}`;
